module.exports = __webpack_public_path__ + "img/truckBannerHome.svg";